import React, {useState} from 'react';
import axios from 'axios'
import axiosConfig from '../../../config/axios.config'
import SidePanel from './SidePanel'
import styles from './styles';
import moment from 'moment';
import ManualTrial from './ManualTrial';
import {UserContext} from '../../../Context/UserContext';
import {InstanceContext} from '../../../InstanceContext';
import { QuestionModal, Icons, Toast, SearchBar} from '@xpertdox_js/xdcomponents';
import { trackActivity, trackError } from '../../../utils/activityTracker';

export const AddTrials = props => {
  const {user, userAction} = React.useContext(UserContext);
  const {contextInstance} = React.useContext(InstanceContext);
  const [trials, setTrials] = useState(null);
  const [manual, setManual] = useState(false);
  const [manualTrials, setManualTrials] = useState(null);
  const [enableRemove, setEnableRemove] = useState(false)
  const [manualTrialToEdit, setManualTrialToEdit] = useState(null)
  const [trialToRemove, setTrialsToRemove] = useState([])
  const [confirmRemove, setConfirmRemove] = useState(false)
  const [termToConfirm, setTermToConfirm] = useState(null)
  const [confirmAdd, showConfirmAdd] = useState(false)
  const [notification, setNotification] = useState([]);
  const mounted = React.useRef(true);
  React.useEffect(() => () => mounted.current = false, [])

  const instance = contextInstance || user.instance;
  const fetchTrials = () => {
    // removed 'axiosConfig.auth' as token is updated on login
    Promise.all([
      axios.get(`${axiosConfig.apiUrl}/rt/console/getAddedTrial/${instance}/${user.email}`),
      axios.get(`${axiosConfig.apiUrl}/rt/console/getManualTrials/${instance}`)
    ]).then(
      ([addedTrials, manualTrials]) => {
        if (mounted.current) {
          setTrials(addedTrials.data)
          setManualTrials(manualTrials.data)
        }
      }
    ).catch((err) => {
      if (err && err.response && err.response.status === 403) {
        userAction({type: 'logout'})
      }
    })
  }
  if(!trials && !manualTrials && mounted.current) fetchTrials()

  const manualSaveDone = () => {
    // console.log('done')
    setManual(false)
    fetchTrials()
  }

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  const selectedTrial = (term, confirmSelect) => {
    if(confirmSelect){
      let body = {
        terms: [term],
        instance: instance
      }
      // removed 'axiosConfig.auth' as token is updated on login
      axios.post(`${axiosConfig.apiUrl}/rt/console/addTrial/${user.email}`, body).then(res =>{
        fetchTrials()
        setTermToConfirm(null)
      }).catch(err => {
        console.log(err)
        trackError({ error: err, history: props.history })
        if (err && err.response && err.response.status === 403) {
          userAction({type: 'logout'})
        }
      })
    } else {
      setTermToConfirm(term)
      showConfirmAdd(true)
    }
  }

  const confirmAddTrial = bool => {
    if(bool) selectedTrial(termToConfirm, true)
    showConfirmAdd(false)
    props.refresh()
  }
  const acceptAdd = () => confirmAddTrial(true);
  const declineAdd = () => confirmAddTrial(false);

  const trialClick = (e,t) => {
    handleActivityLogUpdate(`AddTrials.trialClick`)
    if(!enableRemove){
      setManualTrialToEdit(t.forEdit)
      setManual(true)
    } else remove(e,t)
  }

  const remove = (e,t) => {
    e.preventDefault()
    if(!trialToRemove.includes(t._id)) setTrialsToRemove([...trialToRemove, t._id])
    else {
      let arr = [...trialToRemove]
      arr.splice(arr.indexOf(t._id))
      setTrialsToRemove(arr)
    }
  }

  const confirmRemoval = (bool) => {
    if(bool) {
      let body = {
        instance: instance,
        ids: trialToRemove
      }
      // removed 'axiosConfig.auth' as token is updated on login
      axios.post(`${axiosConfig.apiUrl}/rt/console/deleteManual/${user.email}`, body).then(res =>{
        setConfirmRemove(false)
        setEnableRemove(false)
        setTrialsToRemove([])
        fetchTrials()
      }).catch(err => {
        console.log(err)
        trackError({ error: err, history: props.history })
        if (err && err.response && err.response.status === 403) {
          userAction({type: 'logout'})
        }
      })
    } else {
      setConfirmRemove(false)
      setEnableRemove(false)
      setTrialsToRemove([])
    }
  }
  const acceptRemoval = () => confirmRemoval(true);
  const declineRemoval = () => confirmRemoval(false);

  const setRemove = e => {
    if(!enableRemove) {
      setEnableRemove(true)
    }
    else if (enableRemove && trialToRemove && trialToRemove.length > 0) {
      setConfirmRemove(true)
    }
  }
  return (
    <div style={styles.container}>
      <Toast autoDelete={false} autoDeleteTime={3000} toastList={notification} />
      <div style={{width: '100%', paddingRight: '15px'}}>
        <div style={styles.panel}>
          <p className='heading'>Add trials from clinicaltrials.gov</p>
          <div style={{display: 'flex'}}>
            <SearchBar style={{...styles.searchBar}} {...props}
              axiosConfig={{
              ...axiosConfig,
              auth: {
                headers: {
                  ...axiosConfig.auth.headers,
                  "Authorization": axiosConfig.token
                }
              }
            }} addTrials type="trials" selected={selectedTrial}/>
          </div>
          <p style={{...styles.disclaimer, marginTop: '-10px'}}>**The trial will be visible to users until removed manually from the Admin Console or status changed on clinicaltrials.gov</p>
        </div>
        <div style={styles.panel}>
          {!manual && <button onClick={e => setManual(!manual)} style={{...styles.button,marginTop:'5px', marginLeft: '0'}} >
            <span>Manually add a trial not on clinicaltrials.gov</span>
          </button>}
          {manual && <ManualTrial manualTrialToEdit={manualTrialToEdit} setManual={setManual} done={manualSaveDone} {...props}/>}
          <p style={styles.disclaimer}>**The trial will be visible to users until removed manually from the Admin Console</p>
          {(!manual && manualTrials && manualTrials.length !== 0) && <div>
            <div className="divider" style={{marginTop: '25px'}}/>
            <div style={styles.buttonContainer}>
              <p className='heading' style={{marginRight:'auto'}}>Manually Added Trials</p>
              {enableRemove && <button onClick={e => {setEnableRemove(false); setTrialsToRemove([])}} style={styles.button} >
                <span>Cancel</span>
              </button> }
              <button onClick={e => setRemove(e)} style={styles.button} >
                <span>{enableRemove ? 'Confirm' : 'Remove Manually Added Trials'}</span>
              </button>
            </div>
            {manualTrials.map((t,i)=>{
              let trialSelected = trialToRemove.includes(t._id)
              return (
                <div onClick={e => trialClick(e,t)} key={i} style={{...styles.trial, backgroundColor:'#f6f6f6', opacity: trialSelected ? '.5' : '1'}}>
                  <div style={styles.subTrial}>
                    <p style={styles.trialText}>{t.title}</p>
                  </div>
                  <div style={styles.manualTrialDates}>
                    {enableRemove && <Icons icon={trialSelected ? 'check' :'circleAlt'} style={styles.svg}/>}
                    <p style={{...styles.subTrialText, textAlign:'right'}}>Last revised: {moment(t.userLogs[t.userLogs.length-1].created_date).format('l')} by {t.userLogs[t.userLogs.length-1].email}</p>
                    <p style={{...styles.subTrialText, textAlign:'right'}}>Added: {moment(t.created_date).format('l')}</p>
                  </div>
                </div>
              )
            }
          )}
          </div>}
        </div>
      </div>
      <QuestionModal
        question={
          confirmRemove
          ? 'Are you sure you want to remove the selected trials?'
          : `Are you sure you want to add ${termToConfirm ? termToConfirm._id : ''}?`
        }
        disclaimer='Many functionalities related to the added trial will not be available till the next weekly update'
        acceptText={confirmRemove ? 'Remove trials' : 'Add Trial'}
        declineText='Cancel'
        acceptQuestion={confirmRemove ? acceptRemoval : acceptAdd}
        declineQuestion={confirmRemove ? declineRemoval : declineAdd}
        visible={confirmAdd || confirmRemove}
      />
      <SidePanel fetchTrials={fetchTrials} trials={trials} {...props} />
    </div>
  )
}
